// The one test every phone card list uses before loading its next page: the scroll area is at its bottom. It allows a
// pixel, because iPhone scroll positions are fractional - an exact `>=` let a scroll that stopped a fraction short of
// the bottom never load (the ticket list's phone cards did that until 2026-10-12).
export const reachedScrollBottom = (el: { scrollHeight: number; scrollTop: number; clientHeight: number }) =>
  el.scrollHeight - el.scrollTop - el.clientHeight <= 1;
